var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 25.3125C16.6329 25.3125 19.6374 24.068 21.8527 21.8527C24.068 19.6374 25.3125 16.6329 25.3125 13.5C25.3125 10.3671 24.068 7.36257 21.8527 5.1473C19.6374 2.93203 16.6329 1.6875 13.5 1.6875C10.3671 1.6875 7.36257 2.93203 5.1473 5.1473C2.93203 7.36257 1.6875 10.3671 1.6875 13.5C1.6875 16.6329 2.93203 19.6374 5.1473 21.8527C7.36257 24.068 10.3671 25.3125 13.5 25.3125ZM15.1875 9.28125C15.1875 9.7288 15.0097 10.158 14.6932 10.4745C14.3768 10.791 13.9476 10.9688 13.5 10.9688C13.0524 10.9688 12.6232 10.791 12.3068 10.4745C11.9903 10.158 11.8125 9.7288 11.8125 9.28125C11.8125 8.8337 11.9903 8.40448 12.3068 8.08801C12.6232 7.77154 13.0524 7.59375 13.5 7.59375C13.9476 7.59375 14.3768 7.77154 14.6932 8.08801C15.0097 8.40448 15.1875 8.8337 15.1875 9.28125ZM13.5 13.0781C13.8357 13.0781 14.1576 13.2115 14.3949 13.4488C14.6323 13.6862 14.7656 14.0081 14.7656 14.3438V18.5625C14.7656 18.8982 14.6323 19.2201 14.3949 19.4574C14.1576 19.6948 13.8357 19.8281 13.5 19.8281C13.1643 19.8281 12.8424 19.6948 12.6051 19.4574C12.3677 19.2201 12.2344 18.8982 12.2344 18.5625V14.3438C12.2344 14.0081 12.3677 13.6862 12.6051 13.4488C12.8424 13.2115 13.1643 13.0781 13.5 13.0781Z",
    fill: "#FA756D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.688dede679b3f4b65516a10a2be0cd24.svg";
export { ForwardRef as ReactComponent };